<template>
  <div class="hazard-overview">
    <custom-panel>
      <template #title>隐患事件概况</template>
      <template #default>
        <dv-scroll-board :config="config" v-if="dataLoaded"/>
      </template>
    </custom-panel>
  </div>
</template>
<script>
import CustomPanel from '../custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      config: {
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        header: ['实体店', '隐患类型', '隐患描述'],
        columnWidth: [100, 80],
        data:
          [
            /*             ['4402038026', '消防安全', '至少配置2具防烟面具'],
            ['4402037787', '电气安全', '违规拉线供电动车充电'],
            ['4402029140', '基础安全', '必须签署防火自律公约'],
            ['4402026071', '电气安全', '各类安全开关、插座按照规范要求装设'],
            ['4402002323', '消防安全', '营业场所装修、分隔使用可燃材料'],
            ['4402040298', '基础安全', '是否张贴“经营场所禁烟标志”'],
            ['4402002635', '消防安全', '至少配置2具防烟面具'],
            ['4402037761', '电气安全', '插线板质量应符合国标要求'],
            ['4402039817', '消防安全', '室外广告牌、遮阳棚等使用可燃材料'],
            ['4402038988', '电气安全', '违规拉线供电动车充电'] */
          ]
      }
    }
  },
  created () {
    this.getYinHuanShiJianGaiKuang()
  },
  methods: {
    async getYinHuanShiJianGaiKuang () {
      const res = await request.get('/common/yin-huan-shi-jian-gai-kuang')
      this.config.data = res.data.map(item => {
        return [
          item.networkNo,
          item.riskTypeName,
          item.standardDescribe
        ]
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getYinHuanShiJianGaiKuang()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.hazard-overview {
  height: 100%;
}
</style>
